/* bundles-chrome.jsx — shared 100X Equine nav + footer for the Bundles page.
   Static markup mirroring the Gut X PDP chrome (gutx-page.css classes). */
(function () {
  const {
    useState,
    useEffect
  } = React;
  const HOME = '/';
  // Real routes. The original static-handoff .html filenames 404'd on the live site and the
  // 404 template bounced every nav click to the homepage (found 2026-08-13).
  const PDP = '/pages/shop';
  const NAV = [{
    t: 'Shop',
    h: PDP
  }, {
    t: 'Bundles',
    h: '/pages/bundles',
    current: true
  }, {
    t: 'Colic Coverage',
    h: '/pages/colic-coverage'
  }, {
    t: 'Science',
    h: '/pages/science'
  }, {
    t: 'Reviews',
    h: '/pages/reviews'
  }];
  // TWO LOGOS, ONE VISIBLE. Mirrors sections/gutx-header.liquid exactly so the same CSS in
  // gutx-page.css governs both. Desktop (>=750px) shows the composed mark; mobile (<750px)
  // hides it and shows the designer's SVG, which is the mark used on the ads.
  //
  // The SVG entry MUST exist in window.BA (injected by layout/bundles.liquid, sections/shop.liquid
  // and sections/home.liquid). Without it this renders an empty src and mobile shows NO logo at
  // all, because the CSS has already hidden the composed one. That exact bug shipped 2026-08-11.
  const Logo = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "gx-lm-num"
  }, "100"), /*#__PURE__*/React.createElement("img", {
    className: "gx-lm-x",
    src: window.BA["brush-x.png"],
    alt: "X"
  }), /*#__PURE__*/React.createElement("span", {
    className: "gx-lm-pill"
  }, "Equine"), /*#__PURE__*/React.createElement("img", {
    className: "gx-lm-svg",
    src: window.BA["100x-equine-logo.svg"],
    alt: "100X Equine"
  }));
  function Nav() {
    const [menu, setMenu] = useState(false);
    const close = () => setMenu(false);
    useEffect(() => {
      document.body.classList.toggle('m-locked', menu);
      return () => document.body.classList.remove('m-locked');
    }, [menu]);

    // Scroll-to-grey: flag <html> once the page starts scrolling (matches gutx-nav.jsx).
    useEffect(() => {
      const onScroll = () => {
        document.documentElement.setAttribute('data-navscrolled', window.scrollY > 8 ? 'true' : 'false');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, {
        passive: true
      });
      const onKey = e => {
        if (e.key === 'Escape') setMenu(false);
      };
      document.addEventListener('keydown', onKey);
      return () => {
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('keydown', onKey);
      };
    }, []);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "species-bar",
      "data-screen-label": "Species"
    }, /*#__PURE__*/React.createElement("div", {
      className: "species-tabs"
    }, /*#__PURE__*/React.createElement("a", {
      className: "sp-tab active",
      href: HOME
    }, "Horses"), /*#__PURE__*/React.createElement("a", {
      className: "sp-tab",
      href: "/products/jointflexcanine"
    }, "Dogs")), /*#__PURE__*/React.createElement("div", {
      className: "species-note"
    }, /*#__PURE__*/React.createElement("span", null, "Formulated by Dr. Russ Peterson, DVM"), /*#__PURE__*/React.createElement("span", {
      className: "sep"
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "$20,000"), " colic coverage")), /*#__PURE__*/React.createElement("a", {
      className: "species-colic-m",
      href: '/pages/colic-coverage'
    }, /*#__PURE__*/React.createElement("b", null, "$20,000"), " Colic Coverage")), /*#__PURE__*/React.createElement("header", {
      className: "gx-nav",
      "data-screen-label": "00 Nav"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-nav-inner"
    }, /*#__PURE__*/React.createElement("a", {
      className: "gx-nav-logo",
      href: HOME,
      "aria-label": "100X Equine"
    }, Logo), /*#__PURE__*/React.createElement("ul", null, NAV.map(n => /*#__PURE__*/React.createElement("li", {
      key: n.t
    }, /*#__PURE__*/React.createElement("a", {
      href: n.h,
      "aria-current": n.current ? 'page' : undefined
    }, n.t)))), /*#__PURE__*/React.createElement("div", {
      className: "gx-nav-cta"
    }, /*#__PURE__*/React.createElement("a", {
      className: "gx-btn-link gx-nav-phone",
      href: "tel:+18006773574",
      "aria-label": "Call to order 1-800-677-3574"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "gx-nav-phone-ic",
      viewBox: "0 0 24 24",
      width: "15",
      height: "15",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"
    })), /*#__PURE__*/React.createElement("span", null, "1-800-677-3574")), /*#__PURE__*/React.createElement("a", {
      className: "gx-icon-btn gx-nav-phone-m",
      href: "tel:+18006773574",
      "aria-label": "Call to order 1-800-677-3574"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "19",
      height: "19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"
    })), /*#__PURE__*/React.createElement("span", {
      className: "gx-icon-label"
    }, "Call")), /*#__PURE__*/React.createElement("a", {
      className: "gx-btn-link",
      href: "/account"
    }, "Sign in"), /*#__PURE__*/React.createElement("a", {
      className: "gx-btn-link",
      href: "/cart",
      "data-open-cart": "true"
    }, "Cart ", /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--coral)'
      },
      "data-cart-count": "true"
    }, "(0)")), /*#__PURE__*/React.createElement("a", {
      className: "gx-btn gx-btn-primary",
      href: "#build",
      style: {
        padding: '10px 18px',
        fontSize: 14
      }
    }, "Build a bundle"), /*#__PURE__*/React.createElement("a", {
      className: "gx-icon-btn m-only",
      href: "/account",
      "aria-label": "Account"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "19",
      height: "19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    })), /*#__PURE__*/React.createElement("span", {
      className: "gx-icon-label"
    }, "Account")), /*#__PURE__*/React.createElement("a", {
      className: "gx-icon-btn m-only",
      href: "/cart",
      "aria-label": "Cart",
      "data-open-cart": "true"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "19",
      height: "19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "9",
      cy: "20",
      r: "1.4"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "18",
      cy: "20",
      r: "1.4"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 3h2.2l2.3 12.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.3L21 7H5"
    })), /*#__PURE__*/React.createElement("span", {
      className: "gx-icon-label"
    }, "Cart")), /*#__PURE__*/React.createElement("button", {
      className: "m-burger",
      "aria-label": menu ? 'Close menu' : 'Open menu',
      "aria-expanded": menu,
      onClick: () => setMenu(m => !m)
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null))))), /*#__PURE__*/React.createElement("div", {
      className: 'm-scrim' + (menu ? ' open' : ''),
      onClick: close
    }), /*#__PURE__*/React.createElement("div", {
      className: 'm-drawer' + (menu ? ' open' : ''),
      "aria-hidden": !menu
    }, /*#__PURE__*/React.createElement("div", {
      className: "m-drawer-top"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gx-nav-logo"
    }, Logo), /*#__PURE__*/React.createElement("button", {
      className: "m-close",
      "aria-label": "Close menu",
      onClick: close
    }, "×")), /*#__PURE__*/React.createElement("nav", null, NAV.map(n => /*#__PURE__*/React.createElement("a", {
      key: n.t,
      href: n.h,
      onClick: close
    }, n.t))), /*#__PURE__*/React.createElement("div", {
      className: "m-drawer-cta"
    }, /*#__PURE__*/React.createElement("a", {
      className: "gx-btn gx-btn-primary",
      href: "#build",
      onClick: close
    }, "Build a bundle ", /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "→")), /*#__PURE__*/React.createElement("a", {
      className: "gx-btn-link",
      href: "/account",
      onClick: close
    }, "Sign in"))));
  }
  function Footer() {
    return /*#__PURE__*/React.createElement("footer", {
      className: "gx-foot",
      "data-screen-label": "Footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-wrap-wide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-foot-grid"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "gx-foot-brand"
    }, /*#__PURE__*/React.createElement("span", {
      className: "gx-lm-num"
    }, "100"), /*#__PURE__*/React.createElement("img", {
      className: "gx-lm-x",
      src: window.BA["brush-x-white.png"],
      alt: "X"
    }), /*#__PURE__*/React.createElement("span", {
      className: "gx-lm-pill"
    }, "Equine")), /*#__PURE__*/React.createElement("p", {
      className: "gx-foot-tag"
    }, "Liquid equine nutrition. Formulated by Dr. Russ Peterson, DVM, MS, DACVSMR, ISELP. Backed by $20,000 in colic surgery coverage. Made for working barns."), /*#__PURE__*/React.createElement("p", {
      className: "gx-foot-tag",
      style: {
        marginTop: 20,
        fontSize: 11,
        lineHeight: 1.5,
        letterSpacing: 0,
        maxWidth: 360,
        color: 'rgba(255,255,255,0.38)'
      }
    }, "This statement has not been evaluated by the FDA. This product is not intended to diagnose, treat, cure, or prevent any disease.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "Protocols"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/gutx"
    }, "Gut X")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/osteomax"
    }, "Osteo-MAX")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/jointflexplus"
    }, "Joint Flex Plus")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/aminomax"
    }, "Amino-MAX")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/hydramax"
    }, "Hydra-MAX")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/maxcalm"
    }, "Max Calm")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "Learn"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/science"
    }, "The Science")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/reviews"
    }, "Reviews")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/gut_x#faq"
    }, "FAQ")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/colic-coverage"
    }, "Colic Coverage")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/policies/shipping-policy"
    }, "Free Shipping")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/policies/refund-policy"
    }, "Return Policy")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "More from 100X"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/bundles"
    }, "Bundles")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/equimassager"
    }, "EquiMassager")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/products/jointflexcanine"
    }, "Joint Flex Canine")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "Company"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/about"
    }, "About")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/about"
    }, "Dr. Peterson")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/#wholesale"
    }, "Wholesale")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/#careers"
    }, "Careers")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/#sponsorships"
    }, "Sponsorships")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: "/pages/store-locator"
    }, "Store Locator"))))), /*#__PURE__*/React.createElement("div", {
      className: "gx-foot-bottom"
    }, /*#__PURE__*/React.createElement("div", null, "© 2026 100X Equine, LLC. All rights reserved."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: "/policies/privacy-policy"
    }, "Privacy"), " · ", /*#__PURE__*/React.createElement("a", {
      href: "/policies/terms-of-service"
    }, "Terms"), " · ", /*#__PURE__*/React.createElement("a", {
      href: "/policies/privacy-policy#cookies"
    }, "Cookies")))));
  }
  ReactDOM.createRoot(document.getElementById('chrome-top')).render(/*#__PURE__*/React.createElement(Nav, null));
  ReactDOM.createRoot(document.getElementById('chrome-foot')).render(/*#__PURE__*/React.createElement(Footer, null));
})();
